export const DEFAULT_DATE_FORMAT = 'DD MMM YYYY'
export const DEFAULT_DATE_TIME_FORMAT = 'DD MMM YYYY hh:mm A'
